<template>
  <v-skeleton-loader
    class="preview-loader"
    style="aspect-ratio: 1"
    max-height="100%"
    width="100%"
    type="image"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "GalleryViewSkeletonLoader",
})
</script>

<style scoped>
.preview-loader ::v-deep .v-skeleton-loader__image {
  height: 100%;
}
</style>
